import * as R from 'ramda'

export function getValueIndexInRange(amount, arr) {
  return R.pipe(
    R.append(Number.POSITIVE_INFINITY),
    R.aperture(2),
    R.findIndex(([min, max]) => amount >= min && amount < max)
  )(arr)
}
